<script setup lang="ts">
import { onBeforeMount, PropType, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import { toastApiResult } from "@/toaster";
import { loadingWrapper } from "@/api/helpers/loadingWrapper";
import NotificationEventsManager from "@/modules/users/components/NotificationEventsManager.vue";

const props = defineProps({
	user: {
		type: Object as PropType<App.Data.UserDO>,
		require: true,
	},
});

// Emit is not used in this component but required through the tabs-router-view setup.
const emit = defineEmits(["update-user"]);

const availableNotificationEvents: Ref<App.Data.NotificationEventDO[]> = ref();

const loadAvailableNotificationEvents = async () => {
	const response = await loadingWrapper(
		useApiClient("users").getAvailableNotificationEvents(props.user?.uuid)
	);

	if (response.isOk()) {
		availableNotificationEvents.value = response.value;
	}
};

onBeforeMount(() => {
	loadAvailableNotificationEvents();
});

const updateNotificationEvents = async (
	notificationEvents: App.Data.NotificationEventDO[]
) => {
	await toastApiResult(
		useApiClient("users").updateNotificationEvents(
			props.user?.uuid,
			notificationEvents
		)
	);
};
</script>

<template>
	<module-loading>
		<v-card class="pa-5 mt-5" elevation="1">
			<notification-events-manager
				:async-update-function="updateNotificationEvents"
				:configured-notification-events="user.notificationEvents"
				:available-notification-events="availableNotificationEvents"
			/>
		</v-card>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
